"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemDescriptionStyled = exports.ItemHeadlineStyled = exports.ItemOverlineStyled = exports.ImageWrapperStyled = exports.VerticalViewStyled = exports.ContainerStyled = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _styled = require("../../styled");

var _helpers = require("../../helpers");

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  p {\n    margin: 0;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 300;\n    ", " {\n      font-size: 14px;\n      line-height: 21px;\n    }\n  }\n\n  a {\n    color: inherit;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", " {\n    font-size: 18px;\n    line-height: 27px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 400 !important;\n  padding-top: 0.25em;\n  line-height: 0.5em !important;\n  margin-bottom: 15px;\n\n  ", " {\n    font-size: 54px;\n    line-height: 54px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        img {\n          margin: 0 auto;\n          ", ";\n          height: auto;\n          width: auto;\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  img {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n  }\n\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        max-width: 538px;\n        width: auto;\n        margin: 0 auto;\n      }\n\n      ", " {\n        max-width: 227px;\n        width: auto;\n        margin: 0 auto;\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    max-width: 930px;\n  }\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &:before {\n        bottom: 0;\n        height: auto;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  &:before {\n    height: ", "px;\n    position: absolute;\n    top: ", "px;\n    right: ", "px;\n    width: 100%;\n    z-index: -1;\n  }\n\n  ", ";\n\n  ", " {\n    &:before {\n      bottom: 0;\n      height: auto;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, function (_ref2) {
  var $dropHeight = _ref2.theme.$dropHeight;
  return $dropHeight !== null && $dropHeight !== void 0 ? $dropHeight : 0;
}, function (_ref3) {
  var $dropOffset = _ref3.theme.$dropOffset;
  return $dropOffset !== null && $dropOffset !== void 0 ? $dropOffset : 0;
}, function (_ref4) {
  var $dropRightOffset = _ref4.theme.$dropRightOffset;
  return $dropRightOffset !== null && $dropRightOffset !== void 0 ? $dropRightOffset : 0;
}, function (_ref5) {
  var $setBgToBottom = _ref5.theme.$setBgToBottom;
  return $setBgToBottom && (0, _uiKit.css)(_templateObject2());
}, _const.GridBreakpointsMediaDown.lg);
exports.StyledBox = StyledBox;
var ContainerStyled = (0, _uiKit.styled)(_uiKit.Container)(_templateObject3(), _const.GridBreakpointsMediaUp.lg, function (_ref6) {
  var noPadding = _ref6.noPadding;
  return noPadding && "padding: 0;";
});
exports.ContainerStyled = ContainerStyled;
var VerticalViewStyled = (0, _uiKit.styled)('div')(_templateObject4(), function (_ref7) {
  var isScrollView = _ref7.isScrollView;
  return !isScrollView && (0, _uiKit.css)(_templateObject5(), _const.GridBreakpointsMediaDown.lg, _const.GridBreakpointsMediaDown.md);
});
exports.VerticalViewStyled = VerticalViewStyled;
var ImageWrapperStyled = (0, _uiKit.styled)('div')(_templateObject6(), function (_ref8) {
  var isScrollView = _ref8.isScrollView,
      maxHeight = _ref8.maxHeight;
  return !isScrollView && (0, _uiKit.css)(_templateObject7(), _const.GridBreakpointsMediaDown.lg, maxHeight && "max-height:".concat(maxHeight - 60, "px"));
});
exports.ImageWrapperStyled = ImageWrapperStyled;
var ItemOverlineStyled = (0, _uiKit.styled)(_uiKit.HeadingStyled)(_templateObject8(), _styled.Line4Styles, _const.GridBreakpointsMediaDown.lg);
exports.ItemOverlineStyled = ItemOverlineStyled;
var ItemHeadlineStyled = (0, _uiKit.styled)(_uiKit.HeadingStyled)(_templateObject9(), _styled.Line5Styles, _const.GridBreakpointsMediaDown.lg);
exports.ItemHeadlineStyled = ItemHeadlineStyled;
var ItemDescriptionStyled = (0, _uiKit.styled)(_uiKit.Text)(_templateObject10(), _styled.Line3Styles, _const.GridBreakpointsMediaDown.lg);
exports.ItemDescriptionStyled = ItemDescriptionStyled;